import { FeatureFlagWrapper } from '@/components/common/FeatureFlagWrapper';
import type { FeatureFlagKey } from '@/constants/types';
import { capitalizeFirstLetter } from '@/utils/string';
import { Box, Button, Typography } from '@montugroup/design-system';
import { styled, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

interface NavbarMenuProps {
  name: string;
  link: string;
  activeReferal?: boolean;
  handleMenu?: () => void;
  featureFlag?: FeatureFlagKey;
}

const MenuContainer = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  marginLeft: theme.spacing(6),
  listStyle: 'none',
}));

const MenuLink = styled(Link)(() => ({
  textDecoration: 'none',
  color: 'inherit',
}));

const MenuItemBox = styled(Box)(() => ({
  display: 'block',
}));

function NavbarMenuV2({ name, link, activeReferal, handleMenu, featureFlag }: NavbarMenuProps) {
  const theme = useTheme();

  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));

  const handleMenuToggle = () => {
    if (isMobileView) {
      handleMenu?.();
    }
  };

  const navList = (menuName: string, isActiveReferal?: boolean) =>
    menuName === 'Referral' && isActiveReferal ? (
      <Button variant="contained" color="primary">
        REFER A FRIEND
      </Button>
    ) : (
      <Typography variant="body1" sx={(theme) => ({ color: theme.palette.common.white, textTransform: 'none' })}>
        {menuName === 'eScript' ? menuName : capitalizeFirstLetter(menuName)}
      </Typography>
    );

  return (
    <FeatureFlagWrapper flag={featureFlag}>
      <MenuContainer component="li" title={name}>
        <MenuLink to={link} onClick={handleMenuToggle}>
          <MenuItemBox
            sx={{ display: name === 'Referral' && !activeReferal ? 'none' : 'block' }}
            data-testid="menu-item"
          >
            {navList(name, activeReferal)}
          </MenuItemBox>
        </MenuLink>
      </MenuContainer>
    </FeatureFlagWrapper>
  );
}

export default NavbarMenuV2;
